<template>
    <div class="p-3">
        <h3>RL 4.3 10 Besar Kematian Penyakit Rawat Inap </h3>
        <hr>
        <DataTable table-id="table-pasien" title="10 Besar Kematian Penyakit Rawat Inap "
            :filter-configs="filterConfigs" :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-morbiditas/10-besar-kematian-ranap',
                layout: "fitColumns",
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",
                        formatter: "rownum"

                    },
                    {
                        title: "Kelompok ICD-10 ",
                        field: "kode_icd",
                        hozAlign: "center",
                    },
                    {
                        title: "Kelompok Diagnosis Penyakit ",
                        field: "diagnosa",
                    },
                    {
                        title: "Jumlah Pasien Hidup dan Mati Menurut Jenis Kelamin",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "hidup_mati_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "hidup_mati_p",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "hidup_mati_total",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Jumlah Pasien Keluar Mati ",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "mati_l",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "mati_p",
                                hozAlign: "center",
                            },
                            {
                                title: "Total",
                                field: "mati_total",
                                hozAlign: "center",
                            }
                        ]
                    },
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
